export enum ImageSize {
  Thumbnail
}
